// DEBUT BTN LAOD MORE
function AddReadMore() {
  // BREAK TEXT BY INTELIGENT AND PRESERVE LINKS

  var nbCharLimit = 600;
  let isVertical = false;

  // IF MOBILE
  if ($(window).height() > $(window).width()) {
    isVertical = true;
    var nbCharLimit = 200;
  }
  else if ($(window).width() < 1200) {
    var nbCharLimit = 500;
  }

  let readMoreTxt = "► Voir plus";
  let readLessTxt = "◄ Réduire";
  if (prestashop.language.iso_code == 'en') {
    readMoreTxt = "► Read more";
    readLessTxt = "◄ Reduce";
  }


  //Traverse all selectors with this class and manupulate HTML part to show Read More
  $(".addReadMore").each(function () {
    if ($(this).find(".firstSec").length) return;

    var textWithoutHtml = $(this).text();
    var textWithHtml = $(this).html();

    //console.log('textWithoutHtml', textWithoutHtml);
    //console.log('textWithHtml', textWithHtml);
    //console.log('nbCharLimit', nbCharLimit);

    // IF TEXT IS MORE THAN THE LIMIT WE MUST CUT THE TEXT AND ADD BTN
    if (textWithoutHtml.length > nbCharLimit) {

      // MUST DETECT WHERE STOP WITH SEQUENCE OF FIVES WORDS
      const shortTextWithoutHtml = textWithoutHtml.substring(0, nbCharLimit);
      const shortTextWithoutHtmlLastWords = shortTextWithoutHtml.trim().split(" ").slice(-10);

      //console.log('shortTextWithoutHtml', shortTextWithoutHtml);
      //console.log('lasts 10 shortTextWithoutHtmlLastWords', shortTextWithoutHtmlLastWords);

      const last10Words = textWithHtml.trim().split(" ").slice(-10);
      //console.log('lasts 10 words', last10Words);
      let keyBlocker = 0;
      last10Words.forEach(function (key, value) {
        if (key.indexOf('</a>') !== -1) {
          keyBlocker = value;
          //console.log('keyBlocker detected', keyBlocker);
        }
      });

      //let result = textWithoutHtml.indexOf(0, nbCharLimit);
      var firstSet = textWithoutHtml.substring(0, nbCharLimit);
      var secdHalf = textWithoutHtml.substring(nbCharLimit, textWithoutHtml.length);

      /*let result = textWithHtml.indexOf(last10Words[keyBlocker]);
      console.log('keyBlocker', keyBlocker);
      console.log('result', result);
      if (result < 600) {
        result = 600;
      }
      if (isVertical === true) {
        result = 200;
      }
      var firstSet = textWithHtml.substring(0, result + last10Words[keyBlocker].length);
      var secdHalf = textWithHtml.substring(result + last10Words[keyBlocker].length, textWithHtml.length);*/

      var strtoadd = firstSet + "<span class='SecSec'>" + secdHalf + "</span><span class='viewmore'  title='Click to Show More'>" + readMoreTxt + "</span><span class='viewless' title='Click to Show Less'>" + readLessTxt + "</span>";
      $(this).html(strtoadd);
      $(this).closest('#js-product-list-header').css({
        'height': 'unset',
        'overflowY': 'unset'
      });
      //console.log('first text', firstSet);
      //console.log('second text', secdHalf);
    }
  });


  $(document).on("click", ".viewmore", function (event) {
    event.preventDefault();
    $(this).closest(".block-view").addClass("active");
  });

  $(document).on("click", ".viewless", function (event) {
    event.preventDefault();
    $(this).closest(".block-view").removeClass("active");
  });
}
AddReadMore();
